import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=55327da6&scoped=true"
import script from "./IssueList.vue?vue&type=script&lang=js"
export * from "./IssueList.vue?vue&type=script&lang=js"
import style0 from "./IssueList.vue?vue&type=style&index=0&id=55327da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55327da6",
  null
  
)

export default component.exports